/**
 * Text Editor
 *
 * @version 1.0.0
 * @copyright 2018 SEDA.digital GmbH & Co. KG
 */

// NOTE: When importing modules from npm, make sure to check if they use ES6 syntax or not.
// If so, add them to the include regex for babel-loader in webpack.config.js
import ClassLogger from 'ClassLogger';
import EasyMDE from 'easymde';
// to import legacy 3rd party scripts (into the global space) use the script-loader like this:
// import legacyScript from 'script-loader!../../vendor/legacy/script.js';

class TextEditor {
    getClassName() { return 'TextEditor'; }
    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true); // set second parameter to false to disable logging

        if ($('[data-texteditor]').length === 0) return;
        self.init();
    }

    init() {

        $('[data-texteditor]').each(function (item, editor) {
            const $editor = $(editor)[0];
            const $messageCanvas = $(editor).next('[data-texteditor-counter-message]');
            const maxCount = $(editor).data('texteditor-counter');

            const rte = new EasyMDE({
                element: $editor,
                forceSync: true,
                previewClass: "c-user-profile-form__textarea-input",
                toolbar: ["bold", "|", "italic", "|", "heading-1", "|", "heading-2", "|", "heading-3", "|", "unordered-list", "|", "ordered-list"],
            });

            rte.codemirror.on("refresh", function () {

                if (!rte.value()) {
                    $messageCanvas.prepend('noch 0 von ' + maxCount);
                } else {
                    $messageCanvas.text('noch ' + (maxCount - rte.value().length + ' von ' + maxCount));
                }

            });

            rte.codemirror.on("change", function () {

                $messageCanvas.text('noch ' + (maxCount - rte.value().length + ' von ' + maxCount));

            });

        })

    }
}

export default TextEditor;
